import React from 'react'
import PropTypes from 'prop-types'
import { MapControl, ControlPosition } from '@vis.gl/react-google-maps'
import GoogleMapTypeControl from './GoogleMapTypeControl'

const MapTypeControlWrapper = ({ value, onChange }) => (
  <MapControl position={ControlPosition.TOP_LEFT}>
    <GoogleMapTypeControl value={value} onChange={onChange} sx={{ mt: 1, ml: 1 }} />
  </MapControl>
)

MapTypeControlWrapper.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default MapTypeControlWrapper
